import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { apiFetch } from '../../api/api';
import ReactCardFlip from 'react-card-flip';
import QRCode from 'react-qr-code';

export default function GameBoard() {
  const { id } = useParams();

  const [game, setGame] = useState(null);
  const [cardImage, setCardImage] = useState('');
  const [flipped, setFlipped] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadGame = async () => {
    try {
      // 1️⃣ Load game
      const result = await apiFetch(`/api/scavenger/item/${id}`);

      setGame(result);

      // 2️⃣ Load shared card design
      if (result.renderCardDesignId) {
        try {
          const card = await apiFetch(
            `/cards/getById/${result.renderCardDesignId}`
          );


          setCardImage(card?.cardImage || '');
        } catch (err) {
          console.error("Card fetch failed:", err);
        }
      }

    } catch (err) {
      console.error("loadGame error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadGame();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (!game) return <div>No game found</div>;

  return (
    <div
      style={{
        padding: 20,
        height: 'calc(100vh - 60px)',
        overflowY: 'auto',
        boxSizing: 'border-box'
      }}
    >

    <div
      style={{
        maxWidth: 1400,
        margin: '0 auto'
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${game.boardSettings?.columns || 4}, minmax(220px, 1fr))`,
          gap: 20,
          alignItems: 'start'
        }}
      >

        {game.clues.map((c) => {
          const isFlipped = flipped === c.clueNo;

          return (
            <div key={c.clueNo}>

              <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">

                {/* FRONT (SAME IMAGE FOR ALL) */}
                <div
                  onClick={() => setFlipped(c.clueNo)}
                  style={{
                    position: 'relative',
                    width: '100%',
                    aspectRatio: '1.586 / 1',
                    borderRadius: 10,
                    overflow: 'hidden',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                    background: '#fff',
                    cursor: 'pointer'
                  }}
                >
                  {cardImage ? (
                    <img
                      src={cardImage}
                      alt="Card"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  ) : (
                    <div style={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: '#eee'
                    }}>
                      Loading card...
                    </div>
                  )}

                  <div style={{
                    position: 'absolute',
                    top: 10,
                    left: 10,
                    background: 'rgba(0,0,0,0.6)',
                    color: '#fff',
                    padding: '4px 8px',
                    borderRadius: 6,
                    fontSize: 12
                  }}>
                    #{c.clueNo}
                  </div>
                </div>

                {/* BACK (CLUE + QR) */}
                <div
                  onClick={() => setFlipped(null)}
                  style={{
                    position: 'relative',
                    width: '100%',
                    aspectRatio: '1.586 / 1',
                    borderRadius: 10,
                    background: '#f4f4f4',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                    cursor: 'pointer',

                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: 'thin solid black',
                    padding: 10,
                    boxSizing: 'border-box',

                    overflow: 'hidden'
                  }}
                >

                  <div
                    style={{
                      fontSize: 18,
                      fontWeight: 600,
                      textAlign: 'center',
                      marginBottom: 10,
                      maxWidth: '100%'
                    }}
                  >
                    {c.hintFront || 'Scan to continue'}
                  </div>

                  <QRCode
                    value={`${window.location.origin}/lp/${game.landingPageId}/${game._id}/${c.clueNo}`}
                    size={140}
                  />

                </div>


              </ReactCardFlip>

            </div>
          );
        })}

      </div>
    </div>
  </div>
  );
}
